import React from 'react';
import PropTypes from 'prop-types';
import { lighten } from '@mui/material/styles';
import withStyles from '@mui/styles/withStyles';
import { LinearProgress } from '@mui/material';

const CustomLinearProgress = withStyles((theme) => ({
  colorPrimary: {
    backgroundColor: lighten(theme.palette.darkaccent, 0.4),
  },
  barColorPrimary: {
    backgroundColor: theme.palette.darkaccent,
  },
}))(LinearProgress);

// A simple loading animation to indicate "something is happening" whilst the
// user waits for some sort of async action to complete before UI is displayed.
const Loading = ({ isVisible, className }) => {
  if (!isVisible) return null;

  return <CustomLinearProgress className={className} color="primary" />;
};

Loading.propTypes = {
  isVisible: PropTypes.bool,
};

export default Loading;
